const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftCopilot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 23.3 512.1 465.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: -79.674,
    cy: 645.551,
    r: 11.637,
    gradientTransform: "matrix(-10.9605 -13.3892 -12.5901 10.3064 7673.291 -7504.614)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    style: {
      stopColor: "#00aeff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    style: {
      stopColor: "#2253ce"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0736c4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M374 62c-6.7-22.9-27.8-38.7-51.7-38.7h-15.7c-26 0-48.3 18.6-53 44.2l-26.9 146.8 6.7-22.9c6.7-23 27.8-38.8 51.7-38.8h91.4l38.3 14.9 36.9-14.9H441c-23.9 0-45-15.8-51.7-38.7z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: -20.581,
    cy: 641.788,
    r: 11.637,
    gradientTransform: "matrix(9.8803 12.5737 12.1968 -9.5842 -7518.271 6768.395)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffb657"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    style: {
      stopColor: "#ff5f3d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    style: {
      stopColor: "#c02b3c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.5 449.8c6.7 23 27.8 38.9 51.8 38.9h33.4c29.2 0 53.1-23.3 53.9-52.5l3.6-141.5-7.6 26c-6.7 23-27.8 38.7-51.7 38.7h-92.2l-32.9-17.8-35.6 17.8h10.6c24 0 45.1 15.9 51.8 38.9z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 151.476,
    x2: 178.106,
    y1: 452.543,
    y2: 144.451,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    style: {
      stopColor: "#0d91e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    style: {
      stopColor: "#52b471"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    style: {
      stopColor: "#98bd42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937,
    style: {
      stopColor: "#ffc800"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320 23.3H133.4C80 23.3 48 93.7 26.7 164.2 1.4 247.7-31.6 359.4 64 359.4h80.6c24.1 0 45.2-15.9 51.8-39.1 14-49 38.6-134.5 57.9-199.6 9.8-33.1 18-61.5 30.5-79.2 7.1-9.9 18.8-18.2 35.2-18.2",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 154.129,
    x2: 168.669,
    y1: 491.116,
    y2: 155.012,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3dcbff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    style: {
      stopColor: "#0588f7",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320 23.3H133.4C80 23.3 48 93.7 26.7 164.2 1.4 247.7-31.6 359.4 64 359.4h80.6c24.1 0 45.2-15.9 51.8-39.1 14-49 38.6-134.5 57.9-199.6 9.8-33.1 18-61.5 30.5-79.2 7.1-9.9 18.8-18.2 35.2-18.2",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: -46.943,
    cy: 664.318,
    r: 11.637,
    gradientTransform: "matrix(-12.6711 36.2357 43.4092 15.1796 -28974.764 -8263.428)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    style: {
      stopColor: "#8c48ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#f2598a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    style: {
      stopColor: "#ffb152"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192 488.7h186.7c53.3 0 85.3-70.5 106.7-141 25.3-83.5 58.3-195.2-37.3-195.2h-80.6c-24.1 0-45.2 15.9-51.8 39.1-14 49-38.6 134.6-57.9 199.7-9.8 33.1-18 61.5-30.5 79.2-7.2 9.9-18.9 18.2-35.3 18.2",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 352.459,
    x2: 352.268,
    y1: 382.231,
    y2: 290.663,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    style: {
      stopColor: "#f8adfa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    style: {
      stopColor: "#a86edd",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192 488.7h186.7c53.3 0 85.3-70.5 106.7-141 25.3-83.5 58.3-195.2-37.3-195.2h-80.6c-24.1 0-45.2 15.9-51.8 39.1-14 49-38.6 134.6-57.9 199.7-9.8 33.1-18 61.5-30.5 79.2-7.2 9.9-18.9 18.2-35.3 18.2",
    style: {
      fill: "url(#f)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftCopilot);
export default __webpack_public_path__ + "static/media/Microsoft_copilot.0c6579ad0d9543553c601717d7811b71.svg";
export { ForwardRef as ReactComponent };